import {useEffect, useMemo, useRef} from 'react';
import {GetMeshesFilter} from 'api/generated';
import {useChangeParams} from 'hooks';

import AssetFiles from './Assets.Files';
import AssetsModels from './Assets.Models';

interface IAssetsMineProps {}

const AssetsMine = ({}: IAssetsMineProps) => {
  const {searchParams, handleChangeParams} = useChangeParams();

  const types = ['file', 'model'] as const;
  const type = (types.includes(searchParams.get('type')! as (typeof types)[number]) ? searchParams.get('type') : 'file') as (typeof types)[number];

  const filters = Object.keys(GetMeshesFilter);
  const filter = (filters.includes(searchParams.get('filter')!) ? searchParams.get('filter') : 'mine') as GetMeshesFilter;

  const dropdownItems = useMemo(
    () => [
      {id: 'mine-file', label: 'My files', onClick: () => handleChangeParams({filter: 'mine', type: 'file'})},
      {id: 'mine-model', label: 'My models', onClick: () => handleChangeParams({filter: 'mine', type: 'model'})},
      {id: 'collab-file', label: 'Collab files ', onClick: () => handleChangeParams({filter: 'collab', type: 'file'})},
      {id: 'collab-model', label: 'Collab models', onClick: () => handleChangeParams({filter: 'collab', type: 'model'})},
    ],
    [handleChangeParams],
  );

  const isFirstRender = useRef(true);
  useEffect(() => {
    isFirstRender.current = false;
  }, []);

  if (type === 'file') {
    return <AssetFiles filter={filter} dropdownItems={dropdownItems} animate={isFirstRender.current} />;
  }

  if (type === 'model') {
    return <AssetsModels filter={filter} dropdownItems={dropdownItems} animate={isFirstRender.current} />;
  }

  return null;
};

export default AssetsMine;
